import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  Button,
  Col,
} from 'reactstrap';

import { showModal } from '../../actions';

import { APIcreatePage } from '../../api/Pages';

import EmptyStateImage from './components/Image';
import LearnMoreLink from './components/LearnMoreLink';
import WatchLink from './components/WatchLink';

import { addFlashMessage } from '../../helpers/FlashMessages';

const EmptyCustomPages = ({ history, openModal }) => {
  const intl = useIntl();

  const openCreatePageModal = () => {
    openModal({
      className: 'modal-page-create',
      backdrop: 'static',
      initialValues: {
        name: '',
        url: '',
        visibility_mode: 'login_required',
      },
      onConfirm: draft => APIcreatePage({
        name: draft.name,
        url: draft.url,
        visibility_mode: draft.visibility_mode || 'login_required',
        template: draft.template || null,
      }).then((response) => {
        const newPageId = response?.data?.id;

        if (!newPageId) {
          throw new Error('Missing created page id');
        }

        addFlashMessage({
          type: 'success',
          text: intl.formatMessage({ defaultMessage: 'The new Content Portal has been created' }),
        });

        history.push(`/admin/pages/${newPageId}/edit`);
        return true;
      }),
      onCancel: () => {},
    });
  };

  return (
    <div className="empty-state-wrapper row align-items-center justify-content-center">
      <Col lg="5" xs="12">
        <h2>{intl.formatMessage({ defaultMessage: 'Turn your workspace content into beautiful, branded experiences' })}</h2>
        <div className="mt-4">
          {intl.formatMessage({ defaultMessage: 'Forget sending plain links! Content Portals lets you create shareable, professional-looking web pages directly in Stockpress using your workspace content and an easy-to-use drag-and-drop builder.' })}
        </div>
        <Button color="primary" className="mt-4" onClick={openCreatePageModal}>
          {intl.formatMessage({ defaultMessage: 'Create a Content Portal' })}
        </Button>
        <WatchLink videoId="2uBV3EJ2c2w" />
        <LearnMoreLink className="mt-1" url="https://help.stockpress.co/en/articles/7032397-creating-custom-pages" />
      </Col>
      <EmptyStateImage imageUrl="/images/empty-pages/empty-custom-pages-page.png" />
    </div>
  );
};

EmptyCustomPages.propTypes = {
  history: PropTypes.object.isRequired,
  openModal: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  openModal: (params) => {
    dispatch(showModal('AdminPageCreateModal', params));
  },
});

export default withRouter(connect(null, mapDispatchToProps)(EmptyCustomPages));
